export const dashboardRoute = 'dashboard';
export const dashboardRouteWithSlash = `/${dashboardRoute}`;
export const myAccountRoute = 'account';
export const myAccountRouteWithSlash = `/${myAccountRoute}`;
export const myTechServicesRoute = 'tech-services';
export const myTechServicesRouteWithSlash = `/${myTechServicesRoute}`;
export const tutorialtechservices = '/tutorial/tech-services';
export const tutorialhomedevices = '/tutorial/home-devices';
export const tutorialaccount = '/tutorial/account';
export const tutorialmobile = '/tutorial/mobile';
export const familyManagementRoute = `/${myAccountRoute}/family-management`;
export const familyManagementRouteWithSlash = `/${familyManagementRoute}`;
export const signUpRoute = '/signup';
export const loginRouteWithSlash = '/login';
export const underMaintenanceRoute = '/under-maintenance';
